import React, {Component} from 'react';
import {Link} from "react-router-dom";

export class Menu extends Component <any, any> {
    constructor(props: any) {
        super(props);window.scrollTo(0, 0);
        this.state = {};
    }

    isActive(path: string) {
        const current = window.location.pathname || '/';
        if (path === '/home') {
            return current === '/' || current === '/home';
        }
        return current === path || current.indexOf(path + '/') === 0;
    }

    render() {
        const items = [
            {to: '/home', icon: '/img/home-v2/menu-home.svg', label: 'Главная'},
            {to: '/records', icon: '/img/home-v2/menu-records.svg', label: 'Записи'},
            {to: '/chats', icon: '/img/home-v2/menu-chats.svg', label: 'Чаты'},
            {to: '/knowledge-base', icon: '/img/home-v2/menu-knowledge.svg', label: 'База знаний'},
        ];

        return (<menu className='bottom-menu pb-3 pt-3'>
                <div className='mx-w-content menu-wrap'>
                    {items.map(item => (
                        <Link key={item.to} to={item.to} className={this.isActive(item.to) ? 'is-active' : ''}>
                            <img src={item.icon} alt={item.label}/>
                            <div className='txt-middle dark-textc'>{item.label}</div>
                        </Link>
                    ))}
                </div>
            </menu>
        )
    }
}

export default Menu;
